<template>
  <multiselect
    v-model="selectedContact"
    id="ajax"
    label="license_name"
    track-by="id"
    :placeholder="'Silahkan pilih Lisensi/Nomor Whatsapp...'"
    :multiple="clearAndSingle ? true : multiple"
    open-direction="bottom"
    :custom-label="customLabel"
    :options="contactOptions"
    :searchable="true"
    :loading="isLoading"
    :internal-search="false"
    :close-on-select="multiple?false:true"
    :options-limit="300"
    :limit="3"
    :limit-text="limitText"
    :max-height="600"
    :show-no-results="true"
    @open="asyncFind('')"
    :hide-selected="true"
    @search-change="asyncFind"
    @select="checkMultiSelect"
    :show-labels="false"
  >
    <template slot="option" slot-scope="{ option, remove }">
      <span
        >{{ option.license_name + " (" + option.license_phone_number + ")" }}
        <i
          :class="{
            'text-success': option.is_online_status == 1,
            'text-danger': option.is_online_status == 0,
          }"
          :title="option.is_online_status == 1 ? 'Online' : 'Offline'"
          class="fa fa-signal"
        ></i>
      </span>
    </template>
    <template slot="tag" slot-scope="{ option, remove }">
      <span class="custom__tag">
        <span
          >{{ option.license_name + " (" + option.license_phone_number + ")" }}
          <i
            :class="{
              'text-success': option.is_online_status == 1,
              'text-danger': option.is_online_status == 0,
            }"
            :title="option.is_online_status == 1 ? 'Online' : 'Offline'"
            class="fa fa-signal"
          ></i>
        </span>
        <span class="custom__remove" @click="remove(option)">❌</span>
      </span>
    </template>
    <template slot="clear" slot-scope="props">
      <div
        class="multiselect__clear"
        v-if="selectedContact"
        @mousedown.prevent.stop="clearAll(props.search)"
      ></div>
    </template>
    <span slot="noResult">Oops! No elements found.</span>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css"
export default {
  components:{
    multiselect: Multiselect
  },
  props:{
    value : [Array, Object],
    multiple:{
      type: Boolean,
      default: false
    },
    clearable:{
      type: Boolean,
      default: true
    }
  },
  computed: {
    selectedContact:{
      get(){
        return this.value
      },
      set(value){
        this.$emit('input', value)
      }
    },
    clearAndSingle(){
      if(this.clearable && !this.multiple){
        return true
      }
      return false
    }
  },  
  data() {
    return {
      isLoading: false,
      contactOptions: [], 
      contactListParam: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20,
      },
    };
  },
  watch:{
    selectedContact(val, oldVal) {
      if (val.length > 1 && this.clearAndSingle) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.$emit("input", val);
        }
    }
  },
  methods: { 
    customLabel({ license_name, license_phone_number }) {
      return `${license_name} – ${license_phone_number}`;
    },
    limitText(count) {
      return `and ${count} other`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.license_name = query;
      this.$store
        .dispatch("license/getLicenseList", this.contactListParam)
        .then((response) => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          // console.log("query: ", query);
          // console.log("contactOptions: ", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch((error) => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
  },
};
</script> 


// WEBPACK FOOTER //
// src/views/license/licenseSelect.vue